import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../..';
import useRequestActivationLink from '../../hooks/useRequestActivationLink';
import useRequestPasswordReset from '../../hooks/useRequestPasswordReset';
import commonStyles from '../Common.module.css';
import BackIcon from '../icons/BackIcon';
import Spinner from '../spinners/Spinner';
import styles from './Login.module.css';

function ForgotPassword() {
    const navigate = useNavigate();
    const requestPasswordReset = useRequestPasswordReset();
    const requestActivationLink = useRequestActivationLink();
    const authStore = useAuthStore();
    const [email, setEmail] = useState("");
    const [isResetCompleted, setIsResetCompleted] = useState(false);
    const [isActivationRequred, setIsActivationRequired] = useState(false);
    const [isActivationCompleted, setIsActivationCompleted] = useState(false);

    const requestPasswordResetInner = async () => {
        const response = await requestPasswordReset(email);
        setIsActivationRequired(response.isActivationRequired);
        setIsResetCompleted(!response.isActivationRequired);
    };

    const requestActivationLinkInternal = async () => {
        await requestActivationLink(email);
        setIsActivationRequired(false);
        setIsActivationCompleted(true);
    }

    const back = () => navigate("/login");

    return (
        <div className={styles.background}>
            {!isResetCompleted && !isActivationRequred && !isActivationCompleted && (
                <div className={styles.container} onKeyUp={e => e.key === "Enter" && requestPasswordResetInner()}>
                    <BackIcon className={styles.backIcon} onClick={back} />
                    <a href="/" className={styles.logoLink}></a>
                    <div className={styles.row}>
                        Please provide your email address and we'll send you instructions on how to change your password.
                    </div>
                    <div className={styles.row}>
                        <label className={styles.label}>
                            EMAIL
                            <input
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                type="email"
                                placeholder="Email"
                                autoFocus
                                autoComplete="off"
                            />
                        </label>
                    </div>
                    <div className={[styles.rowHigh, styles.rowRight].join(" ")}>
                        {authStore.isLoading ? (
                            <Spinner className={styles.loginSpinner} />
                        ) : (
                            <button className={commonStyles.primaryButton} onClick={requestPasswordResetInner}>
                                Reset Password
                            </button>
                        )}
                    </div>
                </div>
            )}
            {isResetCompleted && (
                <div className={styles.container}>
                    <BackIcon className={styles.backIcon} onClick={back} />
                    <a href="/" className={styles.logoLink}></a>
                    <div className={styles.row}>
                        Please check for your Inbox for the password reset email.
                    </div>
                </div>
            )}
            {isActivationRequred && (
                <div className={styles.container} onKeyUp={e => e.key === "Enter" && requestActivationLinkInternal()}>
                    <BackIcon className={styles.backIcon} onClick={back} />
                    <a href="/" className={styles.logoLink}></a>
                    <div className={styles.row}>
                        Activation Needed
                    </div>
                    <div className={styles.row}>
                        This account has not been activated yet. Click below to re-send the activation email.
                    </div>
                    <div className={styles.row}>
                        <label className={styles.label}>
                            EMAIL
                            <input
                                value={email}
                                readOnly
                            />
                        </label>
                    </div>
                    <div className={[styles.rowHigh, styles.rowRight].join(" ")}>
                        {authStore.isLoading ? (
                            <Spinner className={styles.loginSpinner} />
                        ) : (
                            <button className={commonStyles.primaryButton} onClick={requestActivationLinkInternal}>
                                Send
                            </button>
                        )}
                    </div>
                </div>
            )}
            {isActivationCompleted && (
                <div className={styles.container}>
                    <a href="/" className={styles.logoLink}></a>
                    <div className={styles.row}>
                        Please check for your Inbox for the activation email.
                    </div>
                </div>
            )}
        </div>
    );
}

export default observer(ForgotPassword);